<template>
    <div>
        <table class="table">
            <tr>
                <th>home_score</th>
                <th>away_score</th>
                <th>match_status</th>
                <th>status</th>
                <th>winner_id</th>
                <th>period_scores</th>
            </tr>
            <tr>
                <td>{{ sport_event_status.home_score }}</td>
                <td>{{ sport_event_status.away_score }}</td>
                <td>{{ sport_event_status.match_status }}</td>
                <td>{{ sport_event_status.status }}</td>
                <td>{{ sport_event_status.winner_id }}</td>
                <td>
                    <div v-for="period_score in sport_event_status.period_scores" style="margin-bottom:10px;" :key="period_score.id">
                        number: {{ period_score.number }}<br>
                        type: {{ period_score.type }}<br>
                        home_score: {{ period_score.home_score }}<br>
                        away_score: {{ period_score.away_score }}<br>
                    </div>
                </td>
            </tr>
        </table>
    </div>
    
</template>

<script>
export default {
    name: 'SoccerScoresMatchStatus',
    props: {
        sport_event_status: ''
    }
}
</script>

